var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper"},[_c('div',{staticClass:"image-wrapper flex-grow-1"},[_c('img',{attrs:{"src":(_vm.baseUrl + "/" + (_vm.roomContent.openedContent))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }